import { baseURL } from "../../Config/envConfig";
import { campaignModuleAPiEndPoints } from "../../Config/APIsEndpoints";
import { testLeadProbeState } from "./integrationLogic";

// Plain fetch (not RTK Query) so a "route missing" answer does not raise the global error snackbar.
// Sends NO campaignId: lds-api 052 must answer that with the 400 envelope and do nothing else.
export async function probeSendTestLead(accessToken, fetchImpl = fetch) {
  try {
    const base = String(baseURL || "").replace(/\/+$/, "");
    const path = campaignModuleAPiEndPoints.sendTestLead.replace(/^\/+/, "");
    const response = await fetchImpl(`${base}/${path}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...(accessToken ? { authorization: `Bearer ${accessToken}` } : {}),
      },
      body: JSON.stringify({ data: {} }),
    });
    let body = null;
    try {
      body = await response.json();
    } catch (e) {
      body = null;
    }
    return testLeadProbeState({ httpStatus: response.status, body });
  } catch (e) {
    return testLeadProbeState({ networkError: true });
  }
}
